import { Asset } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';

/**
 * A basic asset with some default values, used for testing.
 *
 * @param _id
 * @param versions
 * @param filename
 * @param properties
 * @returns
 */
export const mockAsset = (_id: string, version = 1, filename = 'test-file.jpg', properties?: Partial<Asset>): Asset => {
  const asset: AnyType = {
    _id,
    versions: new Array(version),
    mainFile: {
      _id: {},
      name: filename,
      version,
      ext: filename.split('.').pop() || 'jpg',
      mimetype: '',
      size: 4444,
    },
    name: '',
    status: Asset.StatusEnum.Created,
    accessKeys: [''],
    agency: { _id: {}, name: '' },
    assetType: Asset.AssetTypeEnum.Image,
    brand: { _id: {}, name: '' },
    client: { _id: {}, name: '' },
    createdAt: '',
    updatedAt: '',
  };
  return properties ? { ...asset, ...properties } : asset;
};
